export default class LocationProfileSearchRequest {
    locationTypeIds: string[];
    latitude = 0;
    longitude = 0;
    distance = 0;
}